import { components } from '@casanova/casanova-common';

const { CellText } = components.ColumnsCells;

export default [
  {
    label: 'No. de serie',
    field: 'serialNumber',
    renderer: CellText,
    align: 'center',
  },
  {
    label: 'Color',
    field: 'color',
    renderer: CellText,
    align: 'center',
  },
  {
    label: 'No. Motor',
    field: 'engineNumber',
    renderer: CellText,
    align: 'center',
  },
  {
    label: 'Cilindros',
    field: 'cylinder',
    renderer: CellText,
    align: 'center',
  },
  {
    label: 'Transmisión',
    field: 'transmissionType',
    renderer: CellText,
    align: 'center',
  },
  {
    label: 'Combustible',
    field: 'fuelType',
    renderer: CellText,
    align: 'center',
  },
  {
    label: 'Versión',
    field: 'version',
    renderer: CellText,
    align: 'center',
  },
  {
    label: 'Línea',
    field: 'line',
    renderer: CellText,
    align: 'center',
  },
  {
    label: 'Marca',
    field: 'brand',
    renderer: CellText,
    align: 'center',
  },
  {
    label: 'Modelo',
    field: 'model',
    renderer: CellText,
    align: 'center',
  },
  {
    label: 'Estado de placa',
    field: 'countryState',
    renderer: CellText,
    align: 'center',
  },
  {
    label: 'Rol del vehículo',
    field: 'type',
    renderer: CellText,
    align: 'center',
  },
  {
    label: 'Sustituye a la placa:',
    field: 'replaceVehicle',
    renderer: CellText,
    align: 'center',
  },
  {
    label: 'No. placa',
    field: 'plateNumber',
    renderer: CellText,
    align: 'center',
  },
  {
    label: 'Agregado Por',
    field: 'createdByName',
    renderer: CellText,
    align: 'center',
  },
  {
    label: 'Fecha y hora de alta',
    field: 'createdDateFormatted',
    renderer: CellText,
    align: 'center',
  },
  {
    label: 'Categoria contrato virtual:',
    field: 'vcCategoryName',
    renderer: ({ value, ...props }) => (
      <CellText {...props} value={value?.trim() ? value : 'NA'} />
    ),
    align: 'center',
  },
  {
    label: 'Subcategoria contrato virtual:',
    field: 'vcSubcategoryName',
    renderer: ({ value, ...props }) => (
      <CellText {...props} value={value?.trim() ? value : 'NA'} />
    ),
    align: 'center',
  },
  {
    label: 'Unidad principal:',
    field: 'primaryVehicle',
    renderer: CellText,
    align: 'center',
  },
];

export const VEHICLES_ACTIONS = {
  CHANGE_OF_VEHICLE: {
    label: 'Cambio de vehículo',
    name: 'changeOfVehicle',
    disabled: false,
    options: [],
    showExpanded: false,
  },
  LOAN: {
    label: 'Sustituto',
    name: 'loan',
    disabled: false,
    options: [],
    showExpanded: false,
  },
  EDIT_CAT_SUBCAT: {
    label: 'Editar Categoría/Subcategoría',
    name: 'editCategorySubcategory',
    disabled: false,
    options: [],
    showExpanded: false,
  },
};

export const VEHICLE_CARD_ROW_FIELDS = {
  brand: { bold: false },
  line: { bold: true },
  version: { bold: false },
  model: { bold: false },
  serialNumber: { bold: true },
  plateNumber: { bold: true },
  status: { bold: false },
  subStatus: { bold: false },
  vehicleRol: { bold: false },
  primaryVehicle: { bold: false },
  replaceVehicle: { bold: false },
};

export const getContextualMenu = ({ vehicleRol }, isBsTender) => {
  if (vehicleRol !== 'Vehículo Actual' && vehicleRol !== 'Vehículo Anterior') {
    return [];
  }

  if (vehicleRol === 'Vehículo Anterior') {
    return [VEHICLES_ACTIONS.EDIT_CAT_SUBCAT];
  }

  const contextualMenuToSend = [
    VEHICLES_ACTIONS.CHANGE_OF_VEHICLE,
    VEHICLES_ACTIONS.LOAN,
  ];

  if (isBsTender) {
    contextualMenuToSend.push(VEHICLES_ACTIONS.EDIT_CAT_SUBCAT);
  }

  return contextualMenuToSend;
};
